<template>
    <!-- <div class="data-management" :style="rightContentStyle"> -->
    <div class="exploration-wrapper pt-0" :style="rightContentStyle">
        <!-- <RecentActivity /> -->
        <PreDefinedFilters :drawerValue="drawerValue" @showFilterDiv="showFilterDiv"
            @getFilterDetailTopage="getFilterDetailTopage" ref="preFilter" />
        <TableData ref="tableData" @resetFiltersEmitted="resetFiltersEmitted" :filterData="filterData"
            :isLoading="isLoading" :filterDetails="filterDetails" :showFilter="showFilter"
            @update:pagination="handlePaginationUpdate" @getFilterFromTable="getFilterFromTable" />
             <div class="filter-wrapper">
        <Filters v-if="isDataExploration" @drawerStateChanged="handleRightDrawerStateChange"
            @filterApplied="applyFilter" @resetFiltersEmittedUpdated="resetFiltersEmittedUpdated" @drawerValue="holdDrawerValue"
            @updateFilter="callSummaryAgain" ref="filters" />
            </div>
    </div>
    <div v-if="timeoutMessage != ''" class="no-asset-div timeout">
        <div class="text-center">
          {{ timeoutMessage }}
          <v-icon flat @click="fetchFilterData()" color="blue-darken-3" icon="mdi-reload" size="large"></v-icon>
        </div>
      </div>
</template>

<script>
import PreDefinedFilters from "@/components/DataExploration/PreDefinedFilters.vue";
// import RecentActivity from "@/components/DataExploration/RecentActivity.vue";
import TableData from "@/components/DataExploration/TableData.vue";
import Filters from "@/components/layout/Common/Filters.vue";
import screenWidthMixin from "../assets/JS/screenWidthMixin";
import api from "@/axiosInterceptor";
import { mapGetters, mapActions } from "vuex";

export default {
    components: {
        // RecentActivity,
        PreDefinedFilters,
        TableData,
        Filters,
    },
    name: "DataExploration",
    mixins: [screenWidthMixin],
    data: () => ({
        showFilter: true,
        filterData: null,
        currentFilterId: null,
        isLoading: false,
        currentPage: 1,
        currentItemsPerPage: 20,
        filterDetails: null, // Added to store filter details
        isFilterChanged: false, // Added to track if filter has been changed
        drawerValue: false,
        sortColumn: "",
        sortDirection: "",
        timeoutMessage: "",
        // AbortControllers for request cancellation
        filterDataAbortController: null,
        filterDetailsAbortController: null
    }),
    computed: {
        ...mapGetters("tenantId", ["getSelectedTenant"]),
        isDataExploration() {
    const pathSegments = this.$route.path.split('/').filter(Boolean);
    return pathSegments.length > 1 && pathSegments[1] === 'data-management';
},
    },
    methods: {
        ...mapActions("tenantId", ["getUserData"]),
        // Request cancellation methods
        cancelFilterDataRequest() {
            if (this.filterDataAbortController) {
                this.filterDataAbortController.abort();
                this.filterDataAbortController = null;
            }
        },
        cancelFilterDetailsRequest() {
            if (this.filterDetailsAbortController) {
                this.filterDetailsAbortController.abort();
                this.filterDetailsAbortController = null;
            }
        },
        cancelAllRequests() {
            this.cancelFilterDataRequest();
            this.cancelFilterDetailsRequest();
        },
        holdDrawerValue(val) {
            this.drawerValue = val;
        },
        async getFilterDetailTopage(filter) {
            this.$refs.filters.resetFilter();
            this.currentFilterId = filter.ID;
            localStorage.setItem('lastFilterId', filter.ID);
            this.currentPage = 1; // Reset to first page when filter changes
            this.isFilterChanged = true; // Mark filter as changed
            await this.fetchFilterDetails(); // Changed to fetch filter details first
            this.saveFilterDetails(); // Save filter details to localStorage
        },

        async showFilterDiv(val) {
            this.showFilter = val;
        },

        async fetchFilterDetails() {
            // Cancel any previous filter details request
            this.cancelFilterDetailsRequest();
            
            // Create new AbortController for this request
            this.filterDetailsAbortController = new AbortController();
            const signal = this.filterDetailsAbortController.signal;
            
            this.isLoading = true;
            try {
                const response = await api.get(`public/api/filters/${this.currentFilterId}`, { signal });
                if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
                    this.filterDetails = response.data.data.filter; // Store filter details
                    this.saveFilterDetails(); // Save filter details to localStorage
                    this.fetchFilterData(); // Call fetchFilterData after getting filter details
                }
                else if (response && response.data && response.data.message) {
                    console.error(response.data.message);
                }
                else {
                    console.error("Error fetching filter details.");
                }
            } catch (error) {
                // Ignore AbortError - request was cancelled intentionally
                if (error.name === 'AbortError' || error.code === 'ERR_CANCELED') {
                    return;
                }
                console.error("Error fetching filter details:", error);
            } finally {
                this.isLoading = false;
                // Clean up the AbortController
                if (this.filterDetailsAbortController) {
                    this.filterDetailsAbortController = null;
                }
            }
        },
        async getFilterFromTable(filterData) {
            if (filterData.withFilter) {
                this.filterDetails = filterData;
            } else {
                this.filterDetails = {
                    asset: filterData.assets,
                    field: filterData.fields,
                    well: filterData.wells,
                    reservoir: filterData.reservoirs,
                    fluidType: filterData.fluidType,
                    selectedTests: filterData.tests,
                    fluidSampleID: filterData.fluidSampleID, // Added fluidSampleID column
                };
            }
            this.sortColumn = filterData.sortColumn;
            this.sortDirection = filterData.sortDirection;
            this.$refs.filters.populateFieldsFromFilter(this.filterDetails);
            this.saveFilterDetails(); // Save filter details to localStorage
            await this.fetchFilterData();
        },
        
        async fetchFilterData() {
            // Cancel any previous filter data request
            this.cancelFilterDataRequest();
            
            // Create new AbortController for this request
            this.filterDataAbortController = new AbortController();
            const signal = this.filterDataAbortController.signal;
            
            this.isLoading = true;
            this.timeoutMessage ="";
            try {
                const params = {
                    pageSize: this.currentItemsPerPage,
                    pageNumber: this.currentPage,
                    viewSummary: true
                };
                if (this.filterDetails) {
                    params.field = this.filterDetails.field?.length ? `["${this.filterDetails.field.join('","')}"]` : '[]';
                    params.well = this.filterDetails.well?.length ? `["${this.filterDetails.well.join('","')}"]` : '[]';
                    params.asset = this.filterDetails.asset?.length ? `["${this.filterDetails.asset.join('","')}"]` : '[]';
                    params.reservoir = this.filterDetails.reservoir?.length ? `["${this.filterDetails.reservoir.join('","')}"]` : '[]';
                    params.fluidType = this.filterDetails.fluidType?.length ? `["${this.filterDetails.fluidType.join('","')}"]` : '[]';
                    params.sampleType = this.filterDetails.sampleType?.length ? `["${this.filterDetails.sampleType.join('","')}"]` : '[]';
                    params.fluidClassification = this.filterDetails.fluidClassification?.length ? `["${this.filterDetails.fluidClassification.join('","')}"]` : '[]';
                    params.selectedTests = this.filterDetails.selectedTests?.length
                        ? `["${this.filterDetails.selectedTests.map(test => test.toLowerCase().replace(/\s+/g, '')).join('","')}"]`
                        : '[]';
                    if (this.sortColumn) {
                        params.sortColumn = `"${this.sortColumn.replace(/s$/, "")}"`;
                    }

                    // Add sortDirection only if it has a value
                    if (this.sortDirection) {
                        params.sortDirection = `"${this.sortDirection}"`;
                    }
                    // Check for fluidSampleId integration
                    if (this.filterDetails.fluidSampleID?.length) {
                        params.fluidSampleID = `["${this.filterDetails.fluidSampleID.join('","')}"]`;
                    }
                }else{
                    this.$refs.filters.resetFilter();
                }
                const response = await api.get(`public/api/samples`, { params, signal });
                if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
                    this.filterData = response.data.data; // Update filterData with new data
                    if (response.data.data.samples == null) { // Check if no data is available
                        
                       this.filterData = null; // Set filterData to null to indicate no data found
                   }
                    if (this.filterDetails && this.filterDetails.name) {
                        this.$refs.filters.onSelectFilterGet(this.filterDetails.name);
                    }
                   
                    
                }
                else if (response && response.data && response.data.message) {
                    this.timeoutMessage = response.data.message;
                }
                else {
                    this.timeoutMessage = "Error fetching filter details.";
                }
            } catch (error) {
                // Ignore AbortError - request was cancelled intentionally
                if (error.name === 'AbortError' || error.code === 'ERR_CANCELED') {
                    return;
                }
                this.timeoutMessage = error;
            } finally {
                this.isLoading = false;
                // Clean up the AbortController
                if (this.filterDataAbortController) {
                    this.filterDataAbortController = null;
                }
            }
        },
        handleDrawerStateChange(isOpen) {
      if (this.screenWidth >= 768) {
        this.drawerOpen = isOpen;
      }
    },
        async handlePaginationUpdate({ page, itemsPerPage }) {
            this.currentPage = page;
            this.currentItemsPerPage = itemsPerPage;
            if (this.isFilterChanged) { // Check if filter has been changed
                //this.filterData = null;
                // Fetch filter details again on pagination update if filter has been changed
                if (!this.filterDetails || Object.keys(this.filterDetails).every(key => this.filterDetails[key].length === 0)) {
                    await this.fetchFilterData(); // Call fetchFilterData without filter if all filter fields are empty
                } else {
                    if (this.currentFilterId && !this.filterDetails.ID) {
                        await this.fetchFilterDetails();
                    } else {
                        this.fetchFilterData();
                    }
                }
            } else {
                await this.fetchFilterData(); // Call fetchFilterData directly if filter has not been changed
            }
        },

        async resetFiltersEmitted() {
            //this.filterData = null;
            this.currentFilterId = null;
            localStorage.removeItem('lastFilterId');
            localStorage.removeItem('dataManagementFilterDetails'); // Clear saved filter details
            this.currentPage = 1; // Reset to first page after filter reset
            this.currentItemsPerPage = 20; // Reset to default items per page
            this.isFilterChanged = false;
            this.filterDetails = null // Reset filter change flag after filter reset
            this.$refs.filters.resetFilter(); // Call reset function in Filters component
            this.$refs.preFilter.resetCardSelection();
            if (this.$refs.tableData && typeof this.$refs.tableData.resetTableFilter === 'function') {
                this.$refs.tableData.resetTableFilter(); // Example function
            }
            await this.fetchFilterData(); // Call fetchFilterData to reset the table data
        },
        async resetFiltersEmittedUpdated() {
            this.filterDetails = null
            this.currentFilterId = null;
            localStorage.removeItem('dataManagementFilterDetails'); // Clear saved filter details
            this.currentPage = 1; // Reset to first page after filter reset
            this.currentItemsPerPage = 20; // Reset to default items per page
            if (this.$refs.tableData && typeof this.$refs.tableData.resetTableFilter === 'function') {
                this.$refs.tableData.resetTableFilter(); // Example function
            }
            this.$refs.preFilter.resetCardSelection();
            await this.fetchFilterData(); // Call fetchFilterData to reset the table data
        },

        async applyFilter(filterDetails) {
            this.filterDetails = filterDetails.filterData; // Update filterDetails with the new filter
            this.isFilterChanged = true; // Mark filter as changed
            this.currentPage = 1; // Reset to first page when filter changes
            this.$refs.preFilter.CardSelection(filterDetails.filterData);
            this.saveFilterDetails(); // Save filter details to localStorage
            await this.fetchFilterData(); // Fetch new data based on the applied filter
        },
        callSummaryAgain() {
            // this.resetFiltersEmitted()
            this.$refs.preFilter.getFilterSummaries();
        },
        
        saveFilterDetails() {
            // Save current filter details to localStorage for persistence
            if (this.filterDetails) {
                localStorage.setItem('dataManagementFilterDetails', JSON.stringify(this.filterDetails));
            }
        },
    },
    watch: {
  '$route'(to, from) {
    if (to.fullPath !== from.fullPath) {
        // Cancel all pending requests when route changes
        this.cancelAllRequests();
        // Clear filterData immediately when route changes
        this.filterData = null;
        // Reset pagination
        this.currentPage = 1;
        this.currentItemsPerPage = 20;
        // Clear table data in child component
        this.$nextTick(() => {
          if (this.$refs.tableData && typeof this.$refs.tableData.resetTableFilter === 'function') {
            this.$refs.tableData.resetTableFilter();
          }
        });
        this.fetchFilterData();
        this.getUserData();
    }
  },
  getSelectedTenant: {
    handler(newVal, oldVal) {
      // Check if tenant has actually changed (not just initial load)
      if (oldVal && newVal && newVal.ID !== oldVal.ID) {
        // Cancel all pending API requests to prevent old tenant data from loading
        this.cancelAllRequests();
        // Immediately clear filterData to prevent showing old tenant's data
        this.filterData = null;
        // Clear all localStorage filter data
        localStorage.removeItem('lastFilterId');
        localStorage.removeItem('dataManagementFilterDetails');
        localStorage.removeItem('selectedFilterId');
        localStorage.removeItem('pendingFilterData');
        localStorage.removeItem('filterActive');
        localStorage.removeItem('filterApplied');
        localStorage.removeItem('defaultFilter');
        localStorage.removeItem('savedChartData');
        // Reset component state
        this.currentFilterId = null;
        this.filterDetails = null;
        this.isFilterChanged = false;
        this.currentPage = 1;
        this.currentItemsPerPage = 20;
        this.sortColumn = "";
        this.sortDirection = "";
        // Reset child components - use nextTick to ensure refs are available
        this.$nextTick(() => {
          if (this.$refs.filters) this.$refs.filters.resetFilter();
          if (this.$refs.preFilter) this.$refs.preFilter.resetCardSelection();
          if (this.$refs.tableData && typeof this.$refs.tableData.resetTableFilter === 'function') {
            this.$refs.tableData.resetTableFilter();
          }
          // Fetch fresh data for new tenant
          this.fetchFilterData();
        });
      }
    },
    deep: true,
    immediate: false
  }
  },
    mounted() {
     this.getUserData();
        const lastFilterId = localStorage.getItem('lastFilterId');
        const savedFilterDetails = localStorage.getItem('dataManagementFilterDetails');
        
        if (lastFilterId) {
            this.currentFilterId = lastFilterId;
            this.isFilterChanged = true; // Mark filter as changed on component creation if lastFilterId exists
            this.fetchFilterDetails(); // Fetch filter details on component creation if lastFilterId exists
        } else if (savedFilterDetails) {
            // Restore saved filter details if no predefined filter is selected
            try {
                this.filterDetails = JSON.parse(savedFilterDetails);
                this.isFilterChanged = true;
                this.$refs.filters.populateFieldsFromFilter(this.filterDetails);
                this.fetchFilterData();
            } catch (error) {
                console.error('Error parsing saved filter details:', error);
                this.$refs.filters.resetFilter();
                this.fetchFilterData();
            }
        } else {
            this.$refs.filters.resetFilter();
            this.fetchFilterData(); // Call fetchFilterData on component creation to fetch data without filters if lastFilterId does not exist
        }
    },
    async beforeUnmount() {
        // Cancel all pending requests when component is unmounted
        this.cancelAllRequests();
    }
};
</script>